"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _pfaHero = require("@mmc/pfa-hero");
var _pfaHeroV = require("@mmc/pfa-hero-v2");
var _clsx = _interopRequireDefault(require("clsx"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _arrow = _interopRequireDefault(require("../assets/icons/arrow.svg"));
var _pfaHeroCarousel = _interopRequireDefault(require("../styles/pfa-hero-carousel.css"));
var _pfaHeroCarousel2 = _interopRequireDefault(require("./pfa-hero-carousel.props/pfa-hero-carousel.defaultProps"));
var _pfaHeroCarousel3 = _interopRequireDefault(require("./pfa-hero-carousel.props/pfa-hero-carousel.propTypes"));
var _img, _img2;
var _excluded = ["slides", "className", "autoplay", "autoplaySpeed", "cyclical"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;
var ARROW_EVENT_NAME = 'Arrow';
var NEXT_EVENT_NAME = 'NEXT';
var PREVIOUS_EVENT_NAME = 'PREVIOUS';
var PFAHeroCarousel = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function PFAHeroCarousel(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.sliderRef = /*#__PURE__*/_react["default"].createRef();
    _this.showPrevSlide = _this.showPrevSlide.bind(_this);
    _this.showNextSlide = _this.showNextSlide.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    _this.handleClickEvent = _this.handleClickEvent.bind(_this);
    _this.state = {
      showLeftArrow: false,
      showRightArrow: false,
      slides: [],
      className: '',
      autoplay: false,
      autoplaySpeed: 0,
      cyclical: false,
      actionElement: null,
      clickText: null,
      oldSlide: null
    };
    return _this;
  }
  (0, _inheritsLoose2["default"])(PFAHeroCarousel, _React$Component);
  PFAHeroCarousel.resourceType = function resourceType() {
    return 'Pfa_Hero_Carousel_1_0_0';
  };
  var _proto = PFAHeroCarousel.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      data = _this$props.data,
      defaultData = _this$props.defaultData,
      _this$state = this.state,
      slides = _this$state.slides,
      className = _this$state.className,
      autoplay = _this$state.autoplay,
      autoplaySpeed = _this$state.autoplaySpeed,
      cyclical = _this$state.cyclical,
      prevState = (0, _objectWithoutPropertiesLoose2["default"])(_this$state, _excluded);
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    this.setState(_objectSpread({
      slides: componentData.slides,
      className: componentData.className,
      autoplay: componentData.autoplay,
      autoplaySpeed: componentData.autoplaySpeed,
      cyclical: componentData.cyclical
    }, prevState));
    this.handleChange(0, slides.length, cyclical);
  };
  _proto.handleChange = function handleChange(currentSlide, slidesLength, cyclical) {
    var slidesLengthFormatted = slidesLength - 1;
    var isLastSlide = currentSlide === slidesLengthFormatted;
    var isFirstSlide = currentSlide === 0;
    if (cyclical) return null;
    if (isLastSlide && !isFirstSlide) {
      this.setState({
        showLeftArrow: true,
        showRightArrow: false
      });
    } else if (isFirstSlide) {
      this.setState({
        showLeftArrow: false,
        showRightArrow: true
      });
    }
    if (!isLastSlide && !isFirstSlide) {
      this.setState({
        showLeftArrow: true,
        showRightArrow: true
      });
    }
    this.handleClickEvent(currentSlide);
  };
  _proto.getRef = function getRef(c) {
    this.sliderRef.current = c;
  };
  _proto.showPrevSlide = function showPrevSlide() {
    this.setState({
      actionElement: ARROW_EVENT_NAME,
      clickText: PREVIOUS_EVENT_NAME
    });
    this.sliderRef.current.slickPrev();
  };
  _proto.showNextSlide = function showNextSlide() {
    this.setState({
      actionElement: ARROW_EVENT_NAME,
      clickText: NEXT_EVENT_NAME
    });
    this.sliderRef.current.slickNext();
  };
  _proto.handleClickEvent = function handleClickEvent(currentSlide) {
    var _window$dataLayer;
    var _this$state2 = this.state,
      actionElement = _this$state2.actionElement,
      clickText = _this$state2.clickText,
      oldSlide = _this$state2.oldSlide,
      slides = _this$state2.slides;
    var slide = this.state.slides[currentSlide];
    var _ref = slide || {},
      mksTagId = _ref.mksTagId,
      title = _ref.headingLarge;
    var event = {
      event: 'clickevent',
      section_name: mksTagId,
      component: 'Carousel PFA',
      action: actionElement || 'Slider Dot',
      click_text: !actionElement ? currentSlide + 1 + "/" + slides.length : currentSlide > oldSlide ? NEXT_EVENT_NAME : PREVIOUS_EVENT_NAME,
      component_heading: title,
      nameplate: ''
    };
    (_window$dataLayer = window.dataLayer) == null || _window$dataLayer.push(event);
    this.setState({
      actionElement: null,
      clickText: null
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var theme = this.props.theme,
      _this$state3 = this.state,
      slides = _this$state3.slides,
      className = _this$state3.className,
      autoplay = _this$state3.autoplay,
      autoplaySpeed = _this$state3.autoplaySpeed,
      cyclical = _this$state3.cyclical,
      showLeftArrow = _this$state3.showLeftArrow,
      showRightArrow = _this$state3.showRightArrow,
      showPrevSlide = this.showPrevSlide,
      showNextSlide = this.showNextSlide,
      getRef = this.getRef,
      handleChange = this.handleChange;
    var hasOneSlide = slides.length === 1;
    var renderLeftArrow = cyclical || showLeftArrow && !hasOneSlide;
    var renderRightArrow = cyclical || showRightArrow && !hasOneSlide;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _pfaHeroCarousel["default"].wrapper
    }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], {
      ref: getRef,
      className: (0, _clsx["default"])(_pfaHeroCarousel["default"].slider, className),
      dots: true,
      infinite: cyclical,
      speed: 500,
      slidesToShow: 1,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      beforeChange: function beforeChange(oldSlide) {
        return _this2.setState({
          oldSlide: oldSlide
        });
      },
      afterChange: function afterChange(currentSlide) {
        return handleChange(currentSlide, slides.length, cyclical);
      },
      onSwipe: function onSwipe() {
        return _this2.setState({
          actionElement: 'Swipe'
        });
      }
    }, slides.map(function (slide) {
      if (slide.resourceType === 'PFAHero_2_0_0') {
        return /*#__PURE__*/_react["default"].createElement(_pfaHeroV.PFAHeroV2, {
          key: slide.id,
          theme: theme,
          data: slide,
          isCarousel: true
        });
      } else {
        return /*#__PURE__*/_react["default"].createElement(_pfaHero.PFAHero, {
          key: slide.id,
          theme: theme,
          data: slide,
          isCarousel: true
        });
      }
    })), renderLeftArrow && /*#__PURE__*/_react["default"].createElement("button", {
      className: _pfaHeroCarousel["default"].arrow + " " + _pfaHeroCarousel["default"].arrowLeft,
      onClick: showPrevSlide,
      type: "button"
    }, _img || (_img = /*#__PURE__*/_react["default"].createElement("img", {
      src: _arrow["default"],
      alt: "left arrow"
    }))), renderRightArrow && /*#__PURE__*/_react["default"].createElement("button", {
      className: _pfaHeroCarousel["default"].arrow + " " + _pfaHeroCarousel["default"].arrowRight,
      onClick: showNextSlide,
      type: "button"
    }, _img2 || (_img2 = /*#__PURE__*/_react["default"].createElement("img", {
      src: _arrow["default"],
      alt: "right arrow"
    }))));
  };
  return PFAHeroCarousel;
}(_react["default"].Component);
PFAHeroCarousel.displayName = 'PFAHeroCarousel';
PFAHeroCarousel.defaultProps = {
  data: _pfaHeroCarousel2["default"],
  defaultData: _pfaHeroCarousel2["default"]
};